module.exports = __webpack_public_path__ + "static/media/10.df8cf01e.jpg";